import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Row, Col } from "reactstrap";

import AreaTreeView from "./question/AreaTreeView";
import Template from "./question/Template";
import Area from "./question/Area";

const Questions = () => {
    const status = useSelector((state) => state.areaReducer.status)
    const lastCreatedArea = useSelector((state) => state.areaReducer.lastCreatedArea)

    const [isNewArea, setIsNewArea] = useState(null)
    const [area, setArea] = useState(null)
    const [template, setTemplate] = useState(null)

    useEffect(() => {
        if(status === 'area/create/succeeded') {
            setArea(lastCreatedArea)
        }
    }, [status, lastCreatedArea])

    return (
        <div className="app-drawer">
            <div className="bg-white app-drawer-content p-4">
                <Row>
                    <Col md="3">
                        <AreaTreeView 
                            onAreaSelected={ (area) => { setArea(area); setIsNewArea(false); setTemplate(null); }} 
                            onNewArea={() => { setArea(null); setIsNewArea(true); setTemplate(null); }}
                            selectedArea={area} 
                            onTemplateSelected={ (template) => { setArea(null); setIsNewArea(false); setTemplate(template); } } 
                            selectedTemplate={template} 
                        />
                    </Col>
                    <Col md="9">
                        { template ? <Template template={template} /> : null }
                        { area || isNewArea ? <Area area={area} /> : null }
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default Questions;